import { render, staticRenderFns } from "./AppAnalysisColumnCharts.vue?vue&type=template&id=064bd9fe&scoped=true&"
import script from "./AppAnalysisColumnCharts.vue?vue&type=script&lang=js&"
export * from "./AppAnalysisColumnCharts.vue?vue&type=script&lang=js&"
import style0 from "./AppAnalysisColumnCharts.vue?vue&type=style&index=0&id=064bd9fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064bd9fe",
  null
  
)

export default component.exports